module.exports = {
  canvas: require('./canvas'),
  svg: require('./svg')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g@3.3.6@@antv/g/lib/renderers/index.js
// module id = 166
// module chunks = 0